<input class="input" placeholder="Ingrese la dirección del lugar de atención" type="text" #search style="padding: 12px 20px; border: 1px solid #ccc; width: 100%" (keydown.enter)="$event.preventDefault()">
